<template>
  <div id="index">
    <!-- <Hezuo></Hezuo> -->

    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
        <h4 class="header_title">内容文件</h4>
      </header>
      <!-- 内容 -->
      <div class='recommended'>
        <div class="recommended_head">
          <div class="recommended_title flex_start">
            {{detail.title}}
          </div>
          <div class="flex_between author">
            <span class="original">原创:{{detail.user}} {{detail.create_time}}</span>
            <span class="time">专栏：{{detail.conf}}</span>
          </div>
        </div>
        <div class="recommended_center li_r_img" v-html="detail.content"> </div>
        <!-- 文件列表 -->
        <div class="recommended_head" v-if="FileList">
          <div class="recommended_title flex_start">附件 </div>       
          <div class="recommended_head" style="border-bottom:0" v-for="(item, idx) in FileList" :key="idx">
          <div class="flex_between author">
            <span>{{ item.name }}</span>
            <a :href="item.file" download="filename" style="color:dodgerblue;">下载</a>
          </div>
        </div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
      <waterBox />
    </div>
  </div>
</template>

<script>
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import Hezuo from '@/components/tool/m_hezuo.vue'
import waterBox from "@/components/assembly/waterBox.vue";
export default {
  name: "m_column_details",
  data() {
    return {
      head_index: 0,
      id: 0, //推文id
      detail: {}, //内容
      user: {}, //用户信息
      FileList:{},
      is_app: this.$store.state.is_app,
    };
  },
  computed: {
    thousandBitSee: function () { //点赞数
      if (!this.detail.see) return 0;
      let num = this.detail.see;
      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) { // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    }
  },
  components: {
    LoginPrompt,
    Hezuo,
    waterBox
  },
  watch: {

  },
  methods: {
    wxShareFun(type) {
      let that = this;
      this.wxShare(
        that.detail.title,
        that.detail.cover,
        type
      )
    },
    share() { //分享
      let that = this;
      let index = layer.open({
        title: [
          '选择分享',
          'background-color: #FF4351; color:#fff;'
        ],
        content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">分享给好友</div>' +
          '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">分享给朋友圈</div>'
      });
      $('#session').click(() => { //好友
        that.wxShareFun(2);
        layer.close(index);
      })
      $('#circle').click(() => { //朋友圈
        that.wxShareFun(1);
        layer.close(index);
      })

    },
    judgeUser() { //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.prompt.popupFun();
      }
    },
    promptFun() { //提示弹窗回调
      this.$router.push("/m_registered");
    },
    give(type) { //点赞
      let that = this;
      this.$post('share_goods', {
        type: type,
        news_id: this.id
      }).then(res => {
        that.detail.goods = res.data;
      })
    },
    collect(type) { //收藏
      this.judgeUser();
      let that = this;
      this.$post('collect', {
        member_id: this.USER().id,
        news_id: this.id,
        type: type
      }).then(res => {
        layer.open({
          content: type == 1 ? "收藏成功" : '取消收藏成功',
          time: true,
          skin: "msg"
        });
        that.detail.is_collect = that.detail.is_collect == 1 ? 0 : 1;
      })
    },
    addImg() {
      $('.li_r_img img').on("click", function () {
        $(this).ImgZoomIn('');
      });
    },
    comments() { //去评论
      this.$router.push({
        path: '/m_column_comments',
        query: {
          id: this.id
        }
      });
    },
    goBackward() { //返回上一页
      if (window.history.length > 2) {
        this.$router.go(-1)
      } else {
        this.$router.replace('/m_home');
      }
    },
    getUser() {
      let that = this;
      if (this.USER()) {
        this.REFRESH_USER();
        setTimeout(() => {
          that.user = this.USER();
        }, 500)
      }

    },
    sharegoods() { //记录分享次数
      this.$post('share_goods', {
        news_id: this.id,
        type: 1
      }).then(res => {

      })
    },
    getDetails() { //获取详情
      let that = this;
      this.$get('content_detail', {
        news_id: this.id,
        member_id: this.USER().id
      }).then(res => {
        that.detail = res.data.data;
        document.title = that.detail.title;
        that.FileList = JSON.parse(that.detail.fileList);
        that.$nextTick(() => {
          that.addImg();
        })
      }).catch(error => {

        layer.open({
          content: error.message,
          time: 2,
          skin: "msg"
        });
        setTimeout(() => {
          that.goBackward();
        }, 2000)
      });
    },


  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.id = this.$route.query.id;
    this.head_index = this.$route.query.head_index;

    this.getUser();
    this.getDetails();

    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.head_index = this.$route.query.head_index;

    this.getUser();
    this.getDetails();

    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
  }

};
</script>
<style>
.recommended .recommended_center img {
  max-width: 90%;
}

.recommended .recommended_center video {
  max-width: 100%;
  height: auto;
}
</style>
<style scoped>
html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
.recommended_head {
  padding: 1rem 1.5rem;
  border-bottom: 0.05rem solid #dfdfdf;
}

.recommended_head .recommended_title {
  font-size: 1.8rem;
  color: #333;
  font-weight: bold;
}

.recommended_head .recommended_title .tag {
  height: 1.7rem;
  padding: 0 0.7rem;
  border-radius: 0.2rem;
  border: 0.1rem solid #9749bb;
  font-size: 1rem;
  color: #9749bb;
  margin-right: 1rem;
  white-space: nowrap;
}
.li_r_img p {
}
.recommended_head .author {
  margin-top: 1.4rem;
  align-items: flex-start;
}

.recommended_head .author .original {
  color: #666;
  font-size: 1.4rem;
}

.recommended_center {
  padding: 1.2rem 1.6rem;
  font-size: 1.6rem;
  color: #333;
}

.author .time {
  white-space: nowrap;
}

.video_view {
  width: calc(100vw - 3rem);
  margin: 1rem auto;
}

.video_view > video {
  width: 100%;
}

/* 底部按钮 */
.button_buttom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4.8rem;
  border-top: 0.05rem solid #dfdfdf;
  background: #fff;
}

.button_buttom i {
  width: 2rem;
  margin: 0 auto;
}

.button_buttom span {
  font-size: 1.2rem;
  color: #666;
}

.button_buttom .button_left {
  width: 20%;
}

.button_buttom .button_left > i {
  margin-right: 0.45rem;
}

.button_buttom .button_li {
  flex-direction: column;
  text-align: center;
  width: 14vw;
}
</style>



// WEBPACK FOOTER //
// src/components/min_view/m_content_details.vue